<template>
  <p>{{ emptyText }}</p>

  <!-- <md-empty-state md-icon="devices_other" :md-label="emptyText">
  </md-empty-state> -->
</template>

<script>
export default {
  name: 'EmptyData',
  props: {
    emptyText: {
      type: String,
      default: 'No data at the moment',
    },
  },
};
</script>
